import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import BannerImg from '../../assets/mytruehome-banner-img.png';
import BeingHappyImg from '../../assets/being-happy-icon.png';
import HelpCommunityImg from '../../assets/help-your-community-icon.png';
import ChanceToWinImg from '../../assets/chance-to-win-icon.png';
import "./styles.css";
import {
    StyleRow,
    TextBox,
    TextColumn,
    Hashtag,
    BoldText,
    Strong,
    Subtext,
    Button,
    Text,
    TextBox1
} from "./styles";

export const Welcome = ({ toggleForm }) => {
    return (
        <Container fluid>
            <StyleRow className="row">
                <Col sm={12} md={6} lg={7}>
                    <TextBox>
                        <TextColumn>
                            <Hashtag>#MyTrueHome<br/>#SunWestMortgage</Hashtag>
                            <BoldText className="pt-2">True Happiness Comes from</BoldText>
                            <BoldText className="mb-2">Within Because</BoldText>

                            <div className="pt-2 mb-2 d-flex">
                                <div>
                                    <Image fluid src={BeingHappyImg} style={{maxWidth: '50px'}}/>
                                </div>
                                <div className="ps-2">
                                    <Subtext className="welcomeText">
                                        <Strong>Being Happy</Strong>
                                        Share what brings you joy with the hashtags #mytruehome and #sunwestmortgage.
                                    </Subtext>
                                </div>
                            </div>
                            <div className="pt-2 mb-2 d-flex">
                                <div>
                                    <Image fluid src={HelpCommunityImg} style={{maxWidth: '50px'}}/>
                                </div>
                                <div className="ps-2">
                                    <Subtext className="welcomeText">
                                        <Strong>Helps Your Community</Strong>
                                        Your posts raise awareness and money for The Autism Community in Action (TACA)&trade;. For every post, Sun West will donate one dollar to TACA, up to a maximum of $10,000.
                                    </Subtext>
                                </div>
                            </div>
                            <div className="pt-2 mb-2 d-flex">
                                <div>
                                    <Image fluid src={ChanceToWinImg} style={{maxWidth: '50px'}}/>
                                </div>
                                <div className="ps-2">
                                    <Subtext className="welcomeText">
                                        <Strong>Gives You a Chance to Win $1,000</Strong>
                                        Every Wednesday for 11 weeks, Sun West will select one post and award the winner $1,000.
                                    </Subtext>
                                </div>
                            </div>
                            <TextBox1 className="pt-4 mb-4">Your True Home Is Always Within&trade;</TextBox1>
                            <Button onClick={toggleForm} >
                                <Text>Contact Us</Text>
                            </Button> 
                        </TextColumn>
                    </TextBox>
                </Col>
                <Col sm={12} md={6} lg={5} className="d-none d-md-block pe-0">
                    <Image fluid
                        src={BannerImg} className="bannerbg"/>
                </Col>
            </StyleRow>
        </Container>
    );
}